import { Navigate } from "react-router-dom";

export function ProtectLoginRoute(props) {
	const token = localStorage.access_token;

	if (token) {
		return <Navigate to="/" replace />;
	}

	return props.children;
}

export function ProtectMainRoute(props) {
	const token = localStorage.access_token;

	if (!token) {
		return <Navigate to="/login" replace />;
	}

	return props.children;
}
